// extracted by mini-css-extract-plugin
module.exports = {"nav":"NavBAR_nav__2x5of","active":"NavBAR_active__1NY8t","container":"NavBAR_container__2t0Tw","button":"NavBAR_button__3li4s"};